

































































import { Component, Prop } from "vue-property-decorator";
import { Revista, RevistasService } from "@/services/revistas.service";
import DataTable from "@/shared/components/data-table.vue";
import Confirm from "@/shared/components/confirm.vue";
import Tooltip from "@/shared/components/tooltip.vue";
import ImagemAvatar from "@/shared/components/imagem-avatar.vue";
import Manter from "./Manter.vue";
import CardRevista from "./CardRevista.vue";
import { Catalogo, CatalogosService } from "@/services/catalogos.service";
import GlobalMixin from "@/shared/mixins/globalMixin";
import { mixins } from "vue-class-component";

@Component({
  components: {
    DataTable,
    Confirm,
    Tooltip,
    Manter,
    ImagemAvatar,
    CardRevista,
  },
})
export default class Revistas extends mixins(GlobalMixin) {
  @Prop() idCatalogo!: string;

  promise: Promise<Revista[]> | null = null;
  catalogo: Catalogo | null = null;
  headers = [
    { value: "capa", text: "Capa" },
    { value: "nome", text: "Nome" },
    { value: "descricao", text: "Descrição" },
    { value: "ativo", text: "Ativo" },
    { value: "quantidadePaginas", text: "Qtd Paginas" },
    { value: "quantidadeProdutos", text: "Qtd Produtos" },
    { value: "actions", text: "Ações", sortable: false },
  ];
  mounted() {
    this.fetchCatalogo();
    this.fetchRevistas();
  }
  async fetchCatalogo() {
    this.catalogo = await CatalogosService.obterCatalogo(this.idCatalogo);
  }
  fetchRevistas() {
    this.promise = RevistasService.listarRevistasDoCatalogo(this.idCatalogo);
  }
  async novoItem() {
    const modal = this.$refs.manter as Manter;
    await modal.novaRevista();
    this.fetchRevistas();
    const card = this.$refs.cardRevista as CardRevista;
    card.fetchRevista();
  }
  async editarItem(item: Revista) {
    const modal = this.$refs.manter as Manter;
    await modal.editarRevista(item.idRevista);
    this.fetchRevistas();
    const card = this.$refs.cardRevista as CardRevista;
    card.fetchRevista();
  }
  async excluirItem(item: Revista) {
    const modalConfirm = this.$refs.confirm as Confirm;
    const title = `Excluir Revista ${item.nome}`;
    const text = `Deseja realmente excluir a revista e todo seu conteúdo ?`;
    const res = await modalConfirm.open(title, text);
    if (res) {
      this.startLoader();
      await RevistasService.deletarRevistaCompleta(item.idRevista).finally(
        this.stopLoader
      );
      this.fetchRevistas();
      const card = this.$refs.cardRevista as CardRevista;
      card.fetchRevista();
    }
  }
}
